import rentObjectFeatureTagsService from "@/services/rentObjectFeatureTagsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await rentObjectFeatureTagsService.create(formData);
      dispatch(
        "common/showSuccess",
        "Ausstattung wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattung konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      await rentObjectFeatureTagsService.update(formData);
      dispatch(
        "common/showSuccess",
        "Ausstattung wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattung konnte nicht aktualisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await rentObjectFeatureTagsService.findAll(formData);
      commit("setAllFeatureTags", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattungen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectFeatureTagsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Ausstattung wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattung konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAllFeatureTags(state, object) {
    state.all = object;
  },
  setSingleFeatureTag(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
